module.exports = __webpack_public_path__ + "img/GENIO_permisos.990588b2.png";